export const ETIQUETAS_PRODUCTO: Readonly<Record<string, string>> = {
    'Alimentos balanceados para animales': 'Nutrición animal',
    'Alimento balanceado para animales.': 'Nutrición animal',
    'Alimento balanceado para animales': 'Nutrición animal',
    'Alimentos balanceados': 'Nutrición animal',
    'Alimento balanceado': 'Nutrición animal',
};

const CLAVES_ORDENADAS = Object.keys(ETIQUETAS_PRODUCTO).sort(
    (a, b) => b.length - a.length
);

export function etiquetaProducto(valor: string): string {
    return ETIQUETAS_PRODUCTO[valor] ?? valor;
}

export function etiquetaProductoTexto(texto: string | null | undefined): string {
    if (!texto) {
        return texto ?? '';
    }

    return CLAVES_ORDENADAS.reduce(
        (acumulado, clave) =>
            acumulado.split(clave).join(ETIQUETAS_PRODUCTO[clave]),
        texto
    );
}
